//==============================================================================
// Global Constants
//
// Consolidated list of constants reused across different modules and extensions
//==============================================================================

//----------------------------------------------------------
// Attribute names list
//----------------------------------------------------------
export const attrNames = {
    attributeValueItemLTL: "WebstoreLTL",
    attributeValueItemNotAvailable: "NLA",
    attributeValueWidth: "Width (inch)",
    attributeValueWeight: "Weight (lbs)",
    attributeValueLength: "Length (inch)",
    attributeValueKit:"Kit",
    attributeValueModel:"Model",
    attributeValuePart:"Part",
    attributeValueProductType: "ProductType",
    attributeValueWebProductType: "WebProductType",
    attributeValueWebProductLeadTime: "WebProductLeadTime",
    attributeValueShipmentLineDetails: "ShpmtLineDetails",
    attributeValueWebPromoMessage: "WebPromoMessage",
    poBoxVariations: ["P.O. Box", "PO Box", "POBOX", "P.o Box"],
    attributeValuePreviousPartNumbers:"PreviousPartNumbers",
    attributeValueBrand:"Brand",
    attributeValueFitsModels:"Fits Models",
    urlRefinerRefiners: 'refiners',
    itemNumber: 'Item No.',
    itemNumberText: 'Item #: ',
    itemName: 'Item Name',
    partNumber: 'Part No.',
    modelNumber: 'Model No.',
    quantity: 'Qty',
    unitOfMeasure: 'UOM',
    ProductType: "ProductType",
    SearchFor: "Search For:",
    poNumber: "CustomerPurchaseOrder"
};

//----------------------------------------------------------
// Global label resources
//----------------------------------------------------------
export const labelResources = {};
